import { useQuery } from '@tanstack/react-query';
import ruleService from '../../../../services/web/rule-service';

function buildParams({ page, size }) {
    const currentPage = Math.max(0, (page ?? 1) -1);
    return {
        page: currentPage,
        size: size ?? 999999,
    };
}

function mapResponse(root) {
    const content = Array.isArray(root?.content) ? root.content : [];

    const rows = content.map((item) => ({
        ...item,
        visibility_name: item.visibility ?? "",
        devices: item.devicesCount ?? 0,
    }));

    return { 
        rows,
        total: root?.totalElements ?? rows.length,
    };
}

export function useRuleListQuery(params = {}) {
    const queryParams = buildParams(params);
    return useQuery({
        queryKey: ["rule-list", queryParams],
        queryFn: async () => {
            const data = await ruleService.list({}, queryParams);
            return mapResponse(data);
        },
    });
}